import React from 'react';
import PropTypes from 'prop-types';

export const CancelActions = ({
  closeText,
  cancelButtonText,
  cancelPayment,
  closeModal,
}) => {
  return (
    <div>
      <button
        onClick={closeModal}
        className="c-btn c-btn--secondary c-modal__button"
      >
        {closeText}
      </button>
      &nbsp;
      <button
        className="c-btn c-btn--default c-modal__button"
        onClick={cancelPayment}
      >
        {cancelButtonText}
      </button>
    </div>
  );
};

CancelActions.propTypes = {
  cancelPayment: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  closeText: PropTypes.string.isRequired,
  cancelButtonText: PropTypes.string.isRequired,
};
export default CancelActions;
